import React, { useContext, useState } from "react";
import { useSwipeable } from "react-swipeable";
import styled from "styled-components";
import { ProductContext } from "../../assets/icons/tick-circle.svg";
import { useTranslation } from "react-i18next";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--background-color-hover);
`;

const NavRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  margin-top: 8px;

  @media (min-width: 768px) {
    display: none;
  }
`;

const ArrowButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--bg-300);
  background-color: var(--bg-100);
  color: var(--text-100);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  &:not(:disabled):hover {
    background-color: var(--bg-200);
  }
`;

const SliderContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: 24px 0;

  //height: 200px;
  @media (min-width: 768px) {
    max-width: var(--max-width-container);
  }
`;

const SliderContent = styled.div`
  cursor: grabbing;
  display: flex;
  transform: translateX(
    calc(
      -${(props) => props.$currentindex * 80}% - ${(props) => props.$currentindex * 24}px
    )
  );

  transition: transform 0.3s ease-out;
  @media (min-width: 768px) {
    width: 100%;
    display: flex;
    cursor: inherit;
  }
`;
const SliderItem = styled.div`
  flex: 0 0 auto; // Sprečava rastezanje elemenata
  width: 80%; // Širina pojedinačnih elemenata
  margin-right: 24px; // Dodaje prostor između elemenata
  background-color: rgb(235, 242, 244);
  //border: 2px solid black;
  border-radius: 0.375rem;
  @media (min-width: 768px) {
    width: auto;
    flex: 1;
  }
`;
const SliderWrapper = styled.div`
  padding: 14px;
  @media (min-width: 768px) {
    padding: 24px;
  }
`;
const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
`;
const ItemTitle = styled.h4`
  font-size: var(--font-size-large);
  color: var(--text-100);
  font-weight: 300;
  @media (min-width: 768px) {
    font-size: var(--font-size-xlarge);
  }
`;
const ItemText = styled.p`
  font-size: var(--font-size-small);
  margin: 12px 0;
  color: var(--text-100);
  width: 80%;
  font-weight: bold;
  @media (min-width: 768px) {
    font-weight: 300;
    font-size: var(--font-size-base);
  }
`;
const Button = styled.button`
  //min-width: 70%;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  margin: 10px 0;
  gap: 4px;
`;

const Text = styled.span`
  font-size: 16px;
  color: var(--text-100);
`;
const SwiperWrapper = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlers = useSwipeable({
    onSwipedLeft: () =>
      setCurrentIndex((prevIndex) => {
        const maxIndex = getMaxIndex(window.innerWidth, 3);
        return Math.min(prevIndex + 1, maxIndex);
      }),
    onSwipedRight: () =>
      setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0)),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const getMaxIndex = (windowWidth, itemsLength) => {
    if (windowWidth >= 1024) {
      // Pretpostavka za tablet/desktop širinu
      const visibleItems = 3; // Broj elemenata koji staju na ekran
      const maxIndex = Math.ceil(
        itemsLength - visibleItems < 0 ? 0 : itemsLength - visibleItems
      );
      return maxIndex;
    } else if (windowWidth >= 768) {
      // Pretpostavka za tablet/desktop širinu
      const visibleItems = 3; // Broj elemenata koji staju na ekran
      const maxIndex = Math.ceil(
        itemsLength - visibleItems < 0 ? 0 : itemsLength - visibleItems
      );
      return maxIndex;
    }
    return itemsLength - 1; // Za mobilne uređaje, pretpostavka je da se prikazuje 1 element
  };

  const maxIndex = getMaxIndex(window.innerWidth, 3);

  const handlePrev = () => setCurrentIndex((i) => Math.max(i - 1, 0));
  const handleNext = () =>
    setCurrentIndex((i) => Math.min(i + 1, getMaxIndex(window.innerWidth, 3)));

  return (
    <Container>
      <Wrapper>
        <SliderContainer {...handlers}>
          <SliderContent $currentindex={currentIndex}>
            <SliderItem>
              <SliderWrapper>
                <FlexDiv>
                  <ItemTitle>{t("HOME.BECOME_MEMBER")}</ItemTitle>
                  <div>
                    <svg
                      fill="var(--text-100)"
                      version="1.1"
                      id="Ebene_1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 64 64"
                      enable-background="new 0 0 64 64"
                    >
                      <g>
                        <path
                          d="M32,42c8.271,0,15-8.523,15-19S40.271,4,32,4s-15,8.523-15,19S23.729,42,32,42z M32,8c5.963,0,11,6.869,11,15
		s-5.037,15-11,15s-11-6.869-11-15S26.037,8,32,8z"
                        />
                        <path
                          d="M4.103,45.367l-4,12c-0.203,0.61-0.101,1.28,0.275,1.802C0.753,59.691,1.357,60,2,60h60c0.643,0,1.247-0.309,1.622-0.831
		c0.376-0.521,0.479-1.191,0.275-1.802l-4-12c-0.209-0.626-0.713-1.108-1.348-1.29l-14-4c-0.482-0.139-0.996-0.09-1.444,0.134
		L32,45.764l-11.105-5.553c-0.448-0.224-0.962-0.272-1.444-0.134l-14,4C4.815,44.259,4.312,44.741,4.103,45.367z M19.802,44.137
		l11.304,5.652c0.562,0.281,1.227,0.281,1.789,0l11.304-5.652l12.238,3.496L59.226,56H4.774l2.789-8.367L19.802,44.137z"
                        />
                      </g>
                    </svg>
                  </div>
                </FlexDiv>
                <ItemText>{t("HOME.MEMBER_BENEFITS")}</ItemText>
                <Button>{t("HOME.SIGN_UP_HERE")}</Button>
              </SliderWrapper>
            </SliderItem>
            <SliderItem>
              <SliderWrapper>
                <FlexDiv>
                  <ItemTitle>{t("HOME.USUAL_BENEFITS")}</ItemTitle>
                  <div>
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="var(--text-100)"
                        d="M373.344 38.504c-.43.009-18.834 14.371-18.834 14.371l-28.965-5.792c-.212.06-24.143 22.862-24.143 22.862l-25.648-1.539-15.46 16.824-28.073-.722-18.516 20.615-25.371 2.928-17.123 18.37-27.215 8.95-16.062 22.598-23.72 6.224L91.21 184.67l-21.152 11.289-7.401 21.78-23.668 13.95-3.076 23.899c14.712-5.336 28.468.705 38.951 8.4l25.725-15.97 34.922-5.55 30.017-27.085 45.21-5.291 32.97-29.707 32.682-8.178 20.254-26.588c10.445-5.84 25.525-9.99 38.857-15.558l9.799-24.895 28.314-10.77c.154-.168.32-.341.473-.51l3.082-18.761 20.486-15.564c.047-.123.094-.246.139-.368l-15.924-5.943zM256 207.496c-.236 0-.469.004-.705.004a863.75 863.75 0 0 1-8.63 5.045 851.824 851.824 0 0 1-24.214 13.402c10.941-.297 22.144-.45 33.549-.45 61.422 0 117.054 4.476 156.81 11.575 19.879 3.55 35.834 7.816 46.086 12.145 5.127 2.164 8.794 4.391 10.635 5.998.795.693 1.053 1.042 1.23 1.281-.177.24-.435.588-1.23 1.281-1.84 1.607-5.508 3.834-10.635 5.998-10.252 4.329-26.207 8.595-46.085 12.145-39.757 7.1-95.39 11.576-156.811 11.576-60.185 0-114.771-4.304-154.35-11.156-1.062.294-2.148.61-3.197.89-14.957 3.99-28.503 6.543-40.469 7.438 10.618 3.378 23.344 6.348 38.041 8.973 41.316 7.377 97.685 11.855 159.975 11.855 62.29 0 118.659-4.478 159.975-11.855 20.658-3.69 37.506-8.041 49.923-13.284 6.21-2.62 11.343-5.418 15.47-9.02 4.126-3.6 7.632-8.675 7.632-14.84 0-6.167-3.506-11.242-7.633-14.843-4.126-3.6-9.26-6.398-15.469-9.02-12.417-5.242-29.265-9.594-49.923-13.282-41.316-7.378-97.685-11.856-159.975-11.856zm224 80.926c-17.886 9.361-42.297 15.703-70.854 21.017-44.267 8.238-98.66 12.433-153.084 12.815-54.423.382-108.8-3.051-153.021-10.316-22.11-3.633-41.675-8.208-57.629-13.9-4.795-1.712-9.272-3.5-13.412-5.42v112.495c54.727 19.858 139.481 30.383 224 30.383s169.273-10.525 224-30.383zM23.354 421.135a16.182 16.182 0 0 0-.354 3.361c0 6.166 3.506 11.24 7.633 14.842 4.126 3.601 9.26 6.398 15.469 9.02 12.417 5.242 29.265 9.594 49.923 13.283 41.316 7.377 97.685 11.855 159.975 11.855 62.29 0 118.659-4.478 159.975-11.855 20.658-3.69 37.506-8.041 49.923-13.284 6.21-2.62 11.343-5.418 15.47-9.02 4.126-3.6 7.632-8.675 7.632-14.84 0-1.16-.125-2.282-.354-3.362-58.527 21.982-145.45 32.361-232.646 32.361s-174.119-10.38-232.646-32.361z"
                      />
                    </svg>
                  </div>
                </FlexDiv>
                <List>
                  <ListItem>
                    <svg
                      fill="var(--text-100)"
                      width="16px"
                      height="16px"
                      viewBox="0 0 1024 1024"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                      <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
                    </svg>
                    <Text>{t("HOME.ORDER_HISTORY")}</Text>
                  </ListItem>
                  <ListItem>
                    <svg
                      fill="var(--text-100)"
                      width="16px"
                      height="16px"
                      viewBox="0 0 1024 1024"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                      <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
                    </svg>
                    <Text>{t("HOME.SNUS_PREFERENCES")}</Text>
                  </ListItem>
                  <ListItem>
                    <svg
                      fill="var(--text-100)"
                      width="16px"
                      height="16px"
                      viewBox="0 0 1024 1024"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" />
                      <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" />
                    </svg>
                    <Text>{t("HOME.QUICK_ACCESS")}</Text>
                  </ListItem>
                </List>
              </SliderWrapper>
            </SliderItem>
            <SliderItem>
              <SliderWrapper>
                <FlexDiv>
                  <ItemTitle>{t("HOME.IT_TAKES_30_SECONDS")}</ItemTitle>
                  <div>
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z"
                        stroke="var(--text-100)"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </FlexDiv>
                <ItemText>{t("HOME.CONVENIENT_SHOPPING")}</ItemText>
                <Button>{t("HOME.SIGN_UP_HERE")}</Button>
              </SliderWrapper>
            </SliderItem>
          </SliderContent>
        </SliderContainer>
        <NavRow>
          <ArrowButton onClick={handlePrev} disabled={currentIndex === 0} aria-label="Previous">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 6l-6 6 6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ArrowButton>
          <ArrowButton onClick={handleNext} disabled={currentIndex >= maxIndex} aria-label="Next">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ArrowButton>
        </NavRow>
      </Wrapper>
    </Container>
  );
};

export default SwiperWrapper;
